import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const registerDealerRequest = createAction(types.PEN_REGISTER_REQUEST);
export const registerDealerSuccess = createAction(types.PEN_REGISTER_SUCCESS);
export const registerDealerFailure = createAction(types.PEN_REGISTER_FAILURE);

export const getProvidersRequest = createAction(types.PROVIDERS_REQUEST);
export const getProvidersSuccess = createAction(types.PROVIDERS_SUCCESS);
export const getProvidersFailure = createAction(types.PROVIDERS_FAILURE);

export const getProductsRequest = createAction(types.PRODUCTS_REQUEST);
export const getProductsSuccess = createAction(types.PRODUCTS_SUCCESS);
export const getProductsFailure = createAction(types.PRODUCTS_FAILURE);

export const getProviderProductsRequest = createAction(
  types.PROVIDER_PRODUCTS_REQUEST,
);
export const getProviderProductsSuccess = createAction(
  types.PROVIDER_PRODUCTS_SUCCESS,
);
export const getProviderProductsFailure = createAction(
  types.PROVIDER_PRODUCTS_FAILURE,
);

export const createProductRequest = createAction(types.CREATE_PRODUCT_REQUEST);
export const createProductSuccess = createAction(types.CREATE_PRODUCT_SUCCESS);
export const createProductFailure = createAction(types.CREATE_PRODUCT_FAILURE);

export const editProductRequest = createAction(types.EDIT_PRODUCT_REQUEST);
export const editProductSuccess = createAction(types.EDIT_PRODUCT_SUCCESS);
export const editProductFailure = createAction(types.EDIT_PRODUCT_FAILURE);

export const disableProductsRequest = createAction(
  types.DISABLE_PRODUCTS_REQUEST,
);
export const disableProductsSuccess = createAction(
  types.DISABLE_PRODUCTS_SUCCESS,
);
export const disableProductsFailure = createAction(
  types.DISABLE_PRODUCTS_FAILURE,
);

export const getBundleRequest = createAction(types.BUNDLE_REQUEST);
export const getBundleSuccess = createAction(types.BUNDLE_SUCCESS);
export const getBundleFailure = createAction(types.BUNDLE_FAILURE);

export const createBundleRequest = createAction(types.CREATE_BUNDLE_REQUEST);
export const createBundleSuccess = createAction(types.CREATE_BUNDLE_SUCCESS);
export const createBundleFailure = createAction(types.CREATE_BUNDLE_FAILURE);

export const editBundleRequest = createAction(types.EDIT_BUNDLE_REQUEST);
export const editBundleSuccess = createAction(types.EDIT_BUNDLE_SUCCESS);
export const editBundleFailure = createAction(types.EDIT_BUNDLE_FAILURE);

export const initPenConfigRequest = createAction(types.INIT_PEN_CONFIG_REQUEST);
export const initPenConfigSuccess = createAction(types.INIT_PEN_CONFIG_SUCCESS);
export const initPenConfigFailure = createAction(types.INIT_PEN_CONFIG_FAILURE);

export const getCoveragesAndDeductiblesRequest = createAction(
  types.GET_COVERAGES_AND_DEDUCTIBLES_REQUEST,
);

export const resetCoveragesAndDeductibles = createAction(
  types.RESET_COVERAGES_AND_DEDUCTIBLES,
);
export const getCoveragesAndDeductiblesSuccess = createAction(
  types.GET_COVERAGES_AND_DEDUCTIBLES_SUCCESS,
);
export const getCoveragesAndDeductiblesFailure = createAction(
  types.GET_COVERAGES_AND_DEDUCTIBLES_FAILURE,
);

export const getAvailProductsForBundleRequest = createAction(
  types.GET_AVAIL_PRODUCTS_FOR_BUNDLE_REQUEST,
);
export const getAvailProductsForBundleSuccess = createAction(
  types.GET_AVAIL_PRODUCTS_FOR_BUNDLE_SUCCESS,
);
export const getAvailProductsForBundleFailure = createAction(
  types.GET_AVAIL_PRODUCTS_FOR_BUNDLE_FAILURE,
);

export const setPenConfigRequest = createAction(types.SET_PEN_CONFIG_REQUEST);
export const setPenConfigSuccess = createAction(types.SET_PEN_CONFIG_SUCCESS);
export const setPenConfigFailure = createAction(types.SET_PEN_CONFIG_FAILURE);

export const registerProductDealerCodeRequest = createAction(
  types.REGISTER_PRODUCT_DEALER_CODE_REQUEST,
);
export const registerProductDealerCodeSuccess = createAction(
  types.REGISTER_PRODUCT_DEALER_CODE_SUCCESS,
);
export const registerProductDealerCodeFailure = createAction(
  types.REGISTER_PRODUCT_DEALER_CODE_FAILURE,
);

export const registerProductAndGetCoveragesRequest = createAction(
  types.REGISTER_PRODUCT_AND_GET_COVERAGES_REQUEST,
);
export const registerProductAndGetCoveragesSuccess = createAction(
  types.REGISTER_PRODUCT_AND_GET_COVERAGES_SUCCESS,
);
export const registerProductAndGetCoveragesFailure = createAction(
  types.REGISTER_PRODUCT_AND_GET_COVERAGES_FAILURE,
);

export const registerProviderDealerCodeRequest = createAction(
  types.REGISTER_PROVIDER_DEALER_CODE_REQUEST,
);
export const registerProviderDealerCodeSuccess = createAction(
  types.REGISTER_PROVIDER_DEALER_CODE_SUCCESS,
);
export const registerProviderDealerCodeFailure = createAction(
  types.REGISTER_PROVIDER_DEALER_CODE_FAILURE,
);

export const addProviderToDealerRequest = createAction(
  types.ADD_PROVIDER_TO_DEALER_REQUEST,
);
export const addProviderToDealerSuccess = createAction(
  types.ADD_PROVIDER_TO_DEALER_SUCCESS,
);
export const addProviderToDealerFailure = createAction(
  types.ADD_PROVIDER_TO_DEALER_FAILURE,
);

export default {
  registerDealerRequest,
  registerDealerSuccess,
  registerDealerFailure,
  getProvidersRequest,
  getProvidersSuccess,
  editProductRequest,
  editProductSuccess,
  editProductFailure,
  createProductRequest,
  createProductSuccess,
  createProductFailure,
  getProvidersFailure,
  getProductsRequest,
  getProductsSuccess,
  getProductsFailure,
  getProviderProductsRequest,
  getProviderProductsSuccess,
  getProviderProductsFailure,
  initPenConfigRequest,
  initPenConfigSuccess,
  initPenConfigFailure,
  setPenConfigRequest,
  setPenConfigSuccess,
  setPenConfigFailure,
  addProviderToDealerRequest,
  addProviderToDealerSuccess,
  addProviderToDealerFailure,
  getBundleRequest,
  getBundleSuccess,
  getBundleFailure,
  createBundleRequest,
  createBundleSuccess,
  createBundleFailure,
  editBundleRequest,
  editBundleSuccess,
  editBundleFailure,
  disableProductsRequest,
  disableProductsSuccess,
  disableProductsFailure,
  getAvailProductsForBundleRequest,
  getAvailProductsForBundleSuccess,
  getAvailProductsForBundleFailure,
  registerProductDealerCodeRequest,
  registerProductDealerCodeSuccess,
  registerProductDealerCodeFailure,
  registerProductAndGetCoveragesRequest,
  registerProductAndGetCoveragesSuccess,
  registerProductAndGetCoveragesFailure,
  registerProviderDealerCodeRequest,
  registerProviderDealerCodeSuccess,
  registerProviderDealerCodeFailure,
  getCoveragesAndDeductiblesRequest,
  getCoveragesAndDeductiblesSuccess,
  getCoveragesAndDeductiblesFailure,
  resetCoveragesAndDeductibles,
};
